import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import EditModal from "../../../../components/modals/EditModal";
import DeleteModal from "../../../../components/modals/DeleteModal";

import NewAdminForm from '../../../../components/addAdminForm';
import { handleEditAdmin, handleAddAdmin, handleDeleteAdmin } from '../../../../store/actionCreators/admins';

class Supervisors extends Component {
    state = {
        editModal: false,
        deleteModal: false,
        supervisor: null,
        getError: {
            state: false,
            message: ""
        },
        addError: {
            state: false,
            message: ""
        },
        profile_photo: "",
        name: "",
        email: "",
        phone: "",
        password: "",
        directory: "صورة المشرف",
    }

    openEditModal = supervisor => {
        this.setState({
            editModal: true,
            supervisor
        })
    }
    closeEditModal = () => {
        this.setState({
            editModal: false,
            supervisor: null
        })
    }

    openDeleteModal = supervisor => {
        this.setState({
            deleteModal: true,
            supervisor
        })
    }
    closeDeleteModal = () => {
        this.setState({
            deleteModal: false,
            supervisor: null
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
            editError: {
                state: false,
                message: ""
            }
        })
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.setState({directory: event.target.value})
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({profile_photo: e.target.result})
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    updateSupervisor = (adminId, data) => {
        return this.props.dispatch(handleEditAdmin(this.props.match.params.id, adminId, data))
    }

    addNewSupervisor = (profile_photo, name, email, phone, password) => {
        const data = { profile_photo, name, email, phone, password, type: 1 };
        return this.props.dispatch(handleAddAdmin(this.props.match.params.id, data))
    }

    deleteSupervisor = id => {
        return this.props.dispatch(handleDeleteAdmin(1, id))
    }
    
    render() {
        const { editModal, deleteModal, supervisor } = this.state;
        // console.log(this.props)
        if (this.props.supervisors && this.props.supervisors !== null) {
            return (
                <div className="uni-supervisors px-2 py-0 d-flex flex-wrap flex-lg-nowrap">
                    <NewAdminForm addNewAdmin={this.addNewSupervisor} name="مشرف" />
                    <div className="supervisors py-5 px-1 px-lg-3 d-flex flex-wrap align-content-start w-100">
                        {this.props.supervisors.map(admin =>
                            <div className="suber-card p-3 m-1 m-lg-3" key={admin._id}>
                                <div className="suber-card__header d-flex justify-content-between">
                                    <img src={(admin.profile_photo === null || admin.profile_photo === "") ? "/images/user-profile-placeholder-image.png" : admin.profile_photo} alt="مشرف" width="70" height="70" />
                                    <div>
                                        <button title="edit" onClick={() => this.openEditModal(admin)}>
                                            <img className="m-1" src="/icons/edit.png" alt="edit" width="30" />
                                        </button>
                                        <button title="delete" onClick={() => this.openDeleteModal(admin)}>
                                            <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                        </button>
                                    </div>
                                </div>
                                <div className="mt-1">
                                    <h4>{admin.name}</h4>
                                    <h4>{admin.email}</h4>
                                    <h4 className="text-end" style={{direction: "ltr"}}>{admin.phone}</h4>
                                </div>
                            </div>
                        )}
                        {/* <div className="suber-card p-3 m-1 m-lg-3 ">
                            <div className="suber-card__header d-flex justify-content-between">
                                <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                                <div>
                                    <button title="edit">
                                        <img className="m-1" src="/icons/edit.png" alt="edit" width="30" />
                                    </button>
                                    <button title="delete">
                                        <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                    </button>
                                </div>
                            </div>
                            <div className="mt-1">
                                <h4>محمد سمير المصري</h4>
                                <h4>email@university.edu.eg</h4>
                                <h4>+962593496782</h4>
                            </div>
                        </div>
                        <div className="suber-card p-3 m-1 m-lg-3 ">
                            <div className="suber-card__header d-flex justify-content-between">
                                <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                                <div>
                                    <button title="edit">
                                        <img className="m-1" src="/icons/edit.png" alt="edit" width="30" />
                                    </button>
                                    <button title="delete">
                                        <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                    </button>
                                </div>
                            </div>
                            <div className="mt-1">
                                <h4>محمد سمير المصري</h4>
                                <h4>email@university.edu.eg</h4>
                                <h4>+962593496782</h4>
                            </div>
                        </div> */}
                    </div>
                    <EditModal show={editModal} closeEditModal={this.closeEditModal} user={supervisor} updateUser={this.updateSupervisor} />
                    <DeleteModal show={deleteModal} closeDeleteModal={this.closeDeleteModal} user={supervisor} deleteUser={this.deleteSupervisor} />
                </div>
            )
        } else {
            if (this.state.getError.state) {
                return (
                    <div className="m-5">
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="text-center m-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        }
    }
}

function mapStateToProps ({ supervisors }) {
	return {
		supervisors
	}
}

export default withRouter(connect(mapStateToProps)(Supervisors));

